import MaterialTable from 'material-table';
import { defaultGridOptions, tooltipDelay, useGridColDefs } from '../../utils/GridUtils';
import { makeStyles, Tooltip } from '@material-ui/core';
import { centeredCell } from '../../constants/StyleConstants';
import AnimatedButton from '../../components/UI/AnimatedButton';
import { useContext, useEffect, useState } from 'react';
import { LoginContext } from '../../contexts/LoginContext';
import FormatListNumberedOutlinedIcon from '@material-ui/icons/FormatListNumberedOutlined';
import ListAltIcon from '@material-ui/icons/ListAlt';
import { Fragment } from 'react';
import LogisticsConfirmationModal from '../Logistics/LogisticsConfirmationModal';


const useStyles = makeStyles(theme => ({
  centeredCell,
  root: {
    marginTop: '3em',
  },
  gridActions: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    marginBottom: '1em',
  },
  gridControls: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  gridButtonsWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: '1em',
  },
  gridReference: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    columnGap: '1em',
    fontSize: '.8em',
  },
  reference: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  leftSideButton: {
    borderRadius: '1em',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  rightSideButton: {
    borderRadius: '1em',
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  activeGlow: {
    color: 'rgb(0, 255, 0)',
    boxShadow: '0px 0px 10px 0px rgb(0, 255, 0, .5)',
    borderRadius: '50%',
    margin: 0,
    stroke: 'rgb(0, 255, 0, .5)',
    strokeWidth: 4,
    strokeOpacity: 0.7,
  },
  hasNoComments: {
    color: '#BDBDBD',
  },
  sortButton: {
    '&.MuiButton-root': {
      minWidth: 'unset',
    },
    '&.MuiButton-startIcon': {
      margin: 0,
    },
  },
}));

const GridActions = ({
  selectedRows,
  setOpen,
  handleExport,
  loadingExport,
  sort,
  setSort,
  rows,
  ...restProps
}) => {
  const classes = useStyles();
  const { isAllowedByRole } = useContext(LoginContext);
  const [loadingExportSelection, setLoadingExportSelection] = useState(false);
  const [loadingExportAll, setLoadingExportAll] = useState(false);

  useEffect(() => {
    !loadingExport && setLoadingExportSelection(false);
    !loadingExport && setLoadingExportAll(false);
  }, [loadingExport]);

  const exportSelection = () => {
    setLoadingExportSelection(true);
    handleExport(selectedRows.map((r) => r.id))
  };

  const exportAll = () => {
    setLoadingExportAll(true);
    handleExport();
  };

return  (
  <div className={classes.gridControls}>
      <div className={classes.gridButtonsWrapper}>
        <AnimatedButton
          disabled={selectedRows.isEmpty()}
          variant="contained"
          color="primary"
          size="small"
          startIcon={<FormatListNumberedOutlinedIcon />}
          onClick={() => isAllowedByRole() && exportSelection()}
          loading={loadingExportSelection}>
          Exportar selección
        </AnimatedButton>
        <AnimatedButton
          disabled={rows.isEmpty()}
          variant="contained"
          color="primary"
          size="small"
          startIcon={<ListAltIcon />}
          onClick={() => isAllowedByRole() && exportAll()}
          loading={loadingExportAll}>
          Exportar todo
        </AnimatedButton>
       
      </div>
    </div>
  );
};

const ActivityLogsGrid = ({
  data,
  loading,
  tableRef,
  reloadGrid,
  selectedRows,
  setSelectedRows,
  open,
  setOpen,
  gridActions,
}) => {
  const classes = useStyles();

  const BoldValue = ({ value }) => {
    return (<b>{value}</b>);
  };
  
  const colDefs = useGridColDefs([
    { title: 'Fecha', field: 'date', valueType: 'date' },
    { title: 'Usuario', field: 'userFullName'},
    { title: 'Descripción', field: 'activityDescription', valueRender: (value) => 
        (
          <Tooltip
          title={value}
          enterDelay={tooltipDelay}
          enterNextDelay={tooltipDelay}
        >
          <span>
            <BoldValue value={value} /> 
          </span>
            
        </Tooltip>
        )
        
      
    },
    { title: 'Tipo Actividad', field: 'activityType', render: (rowData) => 
        <span>
            {rowData.activityType == 3 ? 'LogIn' : 'LogOut'}
        </span>
        
    },
    

  ]);

  return (
    <Fragment>
      <LogisticsConfirmationModal
        open={open}
        setOpen={setOpen}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        reloadGrid={reloadGrid}
      />
      
      <div className={classes.root}>
        <div className={classes.gridActions}>
          <GridActions selectedRows={selectedRows} loading={loading} setOpen={setOpen} rows={data} {...gridActions} />
        </div>
        <MaterialTable
          {...defaultGridOptions}
          options={{
            ...defaultGridOptions.options,
            pageSizeOptions: [...defaultGridOptions.options.pageSizeOptions, defaultGridOptions.options.pageSizeOptions.last() * 2],
            selection: true,
            headerSelectionProps: { color: 'primary'}, 
            selectionProps: rowData => {
              return {
                color: 'primary',
              };
            },
          }}
          onSelectionChange={(rows, row) => setSelectedRows(rows)}
          columns={colDefs}
          data={data}
          isLoading={loading}
          tableRef={tableRef}
        />
      </div>
    </Fragment>
  );
};

export default ActivityLogsGrid;